import { render } from "./teaSelfLessonInfo.vue?vue&type=template&id=ab4fab06&scoped=true"
import script from "./teaSelfLessonInfo.vue?vue&type=script&lang=js"
export * from "./teaSelfLessonInfo.vue?vue&type=script&lang=js"

import "./teaSelfLessonInfo.vue?vue&type=style&index=0&id=ab4fab06&scoped=true&lang=css"
import "./teaSelfLessonInfo.vue?vue&type=style&index=1&id=ab4fab06&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab4fab06"]])

export default __exports__